import React from 'react';
import { Label, Input, Tooltip, FormGroup } from 'reactstrap';
import HelpPopover from './HelpPopover';

export default class Setting extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      enabled: this.props.enabled,
    };
  }

  switchName() { return `${this.props.slug}-sw`; }
  popoverId() { return `${this.props.slug}-pop`; }

  handleChange = (e) => {
    this.props.notify(this.props.slug, !this.state.enabled);
    this.setState({ enabled: !this.state.enabled });
  }

  renderScrDefault(){
    if (this.state.enabled != this.props.scrDefault){
      return (
        <div className="ms-4">(Scribe Default: {this.props.scrDefault ? 'enabled' : 'disabled' })</div>
      );
    }
  }

  renderOrgDefault(){
    if (this.props.orgDefault != null && this.state.enabled != this.props.orgDefault){
      return (
        <div className="ms-4">(Organization Default: {this.props.orgDefault ? 'enabled' : 'disabled' })</div>
      );
    }
  }

  render() {
    return (<li className="setting-item list-group-item">
      <FormGroup check>
        <Input
          type="checkbox"
          id={this.switchName()}
          onChange={this.handleChange}
          checked={this.state.enabled}
        />
        <Label className="setting-name" htmlFor={this.switchName()} check>
          <span>{this.props.name}</span>
        </Label>
        <div className="settings-description">
          <HelpPopover
            name={this.popoverId()}
            placement="left"
            title={`${this.props.name} Description`}
          >
            {this.props.description}
          </HelpPopover>
        </div>
      </FormGroup>
      {this.renderScrDefault()}
      {this.renderOrgDefault()}
    </li>);
  }
}
